import { render, staticRenderFns } from "./CorporateLenderCard.vue?vue&type=template&id=49560238&"
import script from "./CorporateLenderCard.vue?vue&type=script&lang=js&"
export * from "./CorporateLenderCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports